import {IStateMyPage} from './reducer';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../../common/util/redux';
import {
  IMyPageLikeTabSort,
  IMyPagePurchaseEpisode,
  IMyPageSecondTab,
  ISortV4,
  IRecentV4,
  ILikeV4,
  IPurchaseV4,
} from '../type';

export enum ActionType {
  SetValue = 'myPage.SetValue',
  SetPropertyValues = 'myPage.SetPropertyValues',
  FetchTabSort = 'myPage.FetchTabSort',
  FetchTabItems = 'myPage.FetchTabItems',
  FetchTabEditItems = 'myPage.FetchTabEditItems',
  FetchDeleteTabItems = 'myPage.FetchDeleteTabItems',
  FetchPurchaseContentEpisodes = 'myPage.FetchPurchaseContentEpisodes',
  FetchLikeAlarmToggle = 'myPage.FetchLikeAlarmToggle',
  FetchTogglePurchasedItem = 'myPage.FetchTogglePurchasedItem',
  AddMyPageEpisodes = 'myPage.AddMyPageEpisodes',
  SetLikeAlarm = 'myPage.SetLikeAlarm',
  AddTabItems = 'myPage.AddTabItems',
  TogglePurchasedContent = 'myPage.TogglePurchasedContent',
}

export const actions = {
  ...createBasicActions<IStateMyPage>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  fetchTabSort: (payload: {tab: IMyPageSecondTab; sort: Required<ISortV4>}) =>
    createActionFetch(ActionType.FetchTabSort, {payload}),
  fetchTabItems: (
    payload: {
      tab: IMyPageSecondTab;
      sort?: IMyPageLikeTabSort;
      sortInfo?: Required<ISortV4>;
      isLogin?: boolean;
    },
    isFirst?: boolean
  ) =>
    createActionFetch(ActionType.FetchTabItems, {
      payload,
      fetchKey: payload.tab,
      isFirst,
    }),
  fetchTabEditItems: (
    payload: {tab: IMyPageSecondTab; sort?: string; hideCount?: number},
    isFirst?: boolean
  ) =>
    createActionFetch(ActionType.FetchTabEditItems, {
      payload,
      fetchKey: payload.tab,
      isFirst,
    }),
  fetchDeleteTabItems: ({
    tab,
    ids,
    isRouteToMyPage,
    isLogin,
  }: {
    tab: IMyPageSecondTab;
    ids: number[];
    isRouteToMyPage: boolean;
    isLogin: boolean;
  }) =>
    createActionFetch(ActionType.FetchDeleteTabItems, {
      payload: {tab, ids, isRouteToMyPage, isLogin},
      fetchKey: tab,
    }),
  fetchPurchaseContentEpisodes: (contentId: number, isFirst?: boolean) =>
    createActionFetch(ActionType.FetchPurchaseContentEpisodes, {
      payload: {contentId},
      isFirst,
    }),
  fetchLikeAlarmToggle: (contentId: number, isAlarmOn: boolean) =>
    createActionFetch(ActionType.FetchLikeAlarmToggle, {
      payload: {contentId, isAlarmOn},
      fetchKey: contentId,
    }),
  fetchTogglePurchasedItem: (toggleId: number, isHidden: boolean) =>
    createActionFetch(ActionType.FetchTogglePurchasedItem, {
      payload: {toggleId, isHidden},
      fetchKey: toggleId,
    }),
  addMyPageEpisodes: (data: IMyPagePurchaseEpisode, isFirst?: boolean) =>
    createAction(ActionType.AddMyPageEpisodes, {
      isFirst,
      data,
    }),
  setLikeAlarm: (contentId: number, isAlarmOn: boolean) =>
    createAction(ActionType.SetLikeAlarm, {contentId, isAlarmOn}),
  addTabItems: (payload: {
    tab: IMyPageSecondTab;
    isEdit?: boolean;
    isFirst?: boolean;
    recent?: IRecentV4;
    like?: ILikeV4;
    own?: IPurchaseV4;
  }) => createAction(ActionType.AddTabItems, payload),
  togglePurchasedContent: (toggleId: number, isHidden: boolean) =>
    createAction(ActionType.TogglePurchasedContent, {
      toggleId,
      isHidden,
    }),
};
